import React from 'react';
import * as Styles from './CardFeatures.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import ProTag from '../../ProTag/ProTag';
import { useResize } from '@/hooks/useResize';
import { BREAKPOINTS } from '@/pages/Studio/studio.enum';

const CardFeatures = ({
  CardTitle, CardDescription, Img, isProPlan, showTag, onClick,
}) => {
  const handleTagPro = showTag && !isProPlan;
  const formattedCardTitle = String(CardTitle).toLowerCase().split(' ').join('-');
  const formattedCardTestId = `feature-card-${formattedCardTitle}`;
  const windowRect = useResize();
  const { width } = windowRect;
  const smallDesktop = width < BREAKPOINTS.SMALL_DESKTOP;

  const handleOnClick = () => {
    onClick && onClick();
  };

  return (
    <Styles.CardWrapper onClick={handleOnClick} data-testid={formattedCardTestId}>
      <Styles.CardContent>
        {handleTagPro && (
          <Styles.WrapperTagPro>
            <ProTag size={!smallDesktop ? 'medium' : 'small'} />
          </Styles.WrapperTagPro>
        )}
        <Styles.WrapperTitle>
          <Styles.Title>{CardTitle}</Styles.Title>
        </Styles.WrapperTitle>
        <Styles.Description>{CardDescription}</Styles.Description>
      </Styles.CardContent>

      <Styles.ImageWrapper>
        <Styles.Image src={Img} alt="card" />
      </Styles.ImageWrapper>
    </Styles.CardWrapper>
  );
};
export default withErrorBoundary(CardFeatures, 'CardFeatures');
